import { CanDeactivateFn } from '@angular/router';
import { inject, Injector } from '@angular/core';
import { TerminalInitService } from '@softapps/wws/pos-core';
import { block, handleRequestError } from '@softline/application';
import { SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS } from '@softapps/wws/pos-core';

export const terminalCloseGuard: CanDeactivateFn<any> = async () => {
  const injector = inject(Injector);
  const terminalService = inject(TerminalInitService);

  const posConfig = inject(SOFTLINE_CONFIG_WWS_CASH_REGISTER_PARAMS);

  // when config is explicitly set to false, then skip init/close and activate route
  if (posConfig?.hasTerminal !== undefined && posConfig?.hasTerminal === false) {
    terminalService.state.set(null);
    return true;
  }

  await block(async () => {
    try {
      await terminalService.close();
      terminalService.state.set(null);
      return true;
    } catch (e) {
      handleRequestError(e, injector, { show: false });
      return true;
    }
  }, injector);

  return true;
};
